import { render, staticRenderFns } from "./GeneralPartners.vue?vue&type=template&id=7617bda0"
import script from "./GeneralPartners.vue?vue&type=script&lang=js"
export * from "./GeneralPartners.vue?vue&type=script&lang=js"
import style0 from "./GeneralPartners.vue?vue&type=style&index=0&id=7617bda0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports